.aa{min-width:0px;}